<template>
    <div class="row align-items-center">
        <div class="col">
            <div class="row">
                <div class="col-6" v-for="(teethItem, partIdx) in teeth" :key="partIdx">
                    <div class="row align-items-start m-2" :class="teethItem.class">
                        <div class="col-3 m-0">
                            <span class="badge m-2" v-if="partIdx>=2">&nbsp;</span>
                            <div class="row small">
                                <div v-for="(condition, conditionIdx) in getConditions(partIdx)"
                                     :key="conditionIdx"
                                     class="col-12 mb-1 text-left fixedHeight"
                                     :class="{'bg-light':hovers[condition.value] === partIdx}"
                                >{{ $t(condition.label) }}
                                </div>
                                <div class="col-12 mt-1 fixedHeight" v-if="partIdx<2">&nbsp;</div>
                            </div>
                        </div>
                        <div
                            class="col p-0 m-0 text-center pointer small"
                            v-for="(tooth, toothIdx) in teethItem.items"
                            :key="toothIdx"
                        >
                            <cell
                                v-model="focusedBtn"
                                ref="cell"
                                :x="getX(partIdx, toothIdx)"
                                :y="getY(partIdx, -1)"
                                :tooth="tooth"
                                :state-class="stateClass"
                                :set="set"
                                :part-idx="partIdx"
                                v-if="partIdx>=2"
                                condition="missing"
                                :hovers.sync="hovers"/>

                            <div class="row" v-if="stateClass(tooth, 'missing')">
                                <div class="col-12 mb-1 text-muted small">O</div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-12 mb-1 fixedHeight"
                                     :key="conditionIdx"
                                     v-for="(condition, conditionIdx) in getConditions(partIdx)">
                                    <cell
                                        v-model="focusedBtn"
                                        ref="cell"
                                        :x="getX(partIdx, toothIdx)"
                                        :y="getY(partIdx, conditionIdx)"
                                        :tooth="tooth"
                                        :state-class="stateClass"
                                        :set="set"
                                        :part-idx="partIdx"
                                        :condition="condition.value"
                                        :hovers.sync="hovers"/>
                                </div>
                            </div>
                            <cell
                                v-model="focusedBtn"
                                ref="cell"
                                :x="getX(partIdx, toothIdx)"
                                :y="getY(partIdx, conditions.length)"
                                :tooth="tooth"
                                :state-class="stateClass"
                                :set="set"
                                :part-idx="partIdx"
                                v-if="partIdx<2"
                                condition="missing"
                                :hovers.sync="hovers"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { modalMixins } from '@/mixins/modal.js';
import { conditionsArray } from '@/filters/condition.js';

import { teethComponents } from '@/mixins/all-teeth.js'

import Cell from "@/components/Teeth/Cell";
import dentalCharts from "../dentalCharts";

export default {
    props: ['type', 'value', 'tooths', 'width', 'kid'],
    mixins: [modalMixins, teethComponents],
    components: {
        Cell
    },
    data() {
        return {
            data: {},
            hovers: {},
            states: [],
            conditions: conditionsArray(['missing']),
            focusedBtn: {}
        }
    },
    mounted() {
        window.addEventListener('keydown', this.toothHandler)
    },
    destroyed() {
        window.removeEventListener('keydown', this.toothHandler)
    },
    created() {
        this.states = this.value;
        this.fetchConfigs({})
    },
    watch: {
        value(newVal) {
            this.states = newVal;
        },

        // value: {
        //     handler(newValue) {

        //         this.states = newValue;
        //     },
        //     deep: true,
        // }
    },
    computed: {
        ...mapGetters('configurator', { findConfsInStore: 'find' }),

        teeth() {
            const chart = dentalCharts.find( (item) => {
                return item.value === this.$settings.dentalChart
            })
            return this.kid ? chart.chart.kid : chart.chart.adult
        },

        maxX() {
            return this.teethPerPart(0) + this.teethPerPart(1) - 1
        },

        maxY() {
            return this.conditions.length * 2 + 1
        }
    },
    methods: {
        ...mapActions('configurator', { fetchConfigs: 'find' }),

        getConditions(partIdx) {
            if (partIdx < 2)
                return this.conditions.slice().reverse()
            return this.conditions
        },

        currentTooth(tooth) {
            if (typeof (tooth) == 'object') tooth = tooth.value;
            tooth = tooth > 50 ? tooth - 40 : tooth;

            if ( this.$settings.dentalChart === 'usa' )
                tooth = this.$usa2fdi(tooth);

            if (this.$options.components['Tooth' + tooth])
                return 'tooth' + tooth;
            else
                return 'b-button'
        },

        pushState(tooth, diagnosis, optionId) {
            if (!optionId)
                optionId = (this.findConfsInStore({ query: { condition: diagnosis } }).data[0] || {})._id
            this.states.push({ tooth, diagnosis, option: optionId });
        },

        set(tooth, diagnosis, optionId) {
            let index = this.states.findIndex(i => {
                return tooth == i.tooth && diagnosis == i.diagnosis;
            });
            if (index < 0) {
                this.pushState(tooth, diagnosis, optionId)
            } else {
                let state = this.states[index]
                this.states.splice(index, 1);
                if (optionId && state.option !== optionId)
                    this.pushState(tooth, diagnosis, optionId)
            }
            this.update();

        },
        stateClass(tooth, diagnosis, optionId) {
            let item = this.states.findIndex(el => {
                let match = tooth == el.tooth && diagnosis == el.diagnosis
                if (optionId) return match && el.option === optionId
                return match;
            });

            if (item >= 0)
                return 'active';
            return ''
        },
        update() {
            this.$emit('input', this.states);
        },

        moveFocus(action) {
            let { x, y } = this.focusedBtn
            x = x || 0
            y = y || 0

            switch (action) {
                case 'ArrowDown':
                case 'KeyS':
                    y++;
                    break;
                case 'ArrowLeft':
                case 'KeyA':
                    x--;
                    break;
                case 'ArrowRight':
                case 'KeyD':
                    x++;
                    break;
                case 'ArrowUp':
                case 'KeyW':
                    y--;
                    break;
            }
            if (x > this.maxX) {
                x = this.teethPerPart(0)
                y++;
            }
            if (x < 0)
                return
            if (y < 0 || y > this.maxY)
                return
            let toothRef = this.$refs['cell'].find(el => el.x === x && el.y === y)
            this.focusedBtn = { x, y }
            if (!toothRef) {
                return this.moveFocus(action)
            }
        },

        toothHandler(e) {
            if (['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'KeyW', 'KeyS', 'KeyD', 'KeyA'].includes(e.code))
                e.preventDefault()
            else
                return
            this.moveFocus(e.code)
        },

        teethPerPart(partIndex) {
            return this.teeth[partIndex].items.length
        },

        getX(partIndex, toothIndex) {
            return (partIndex % 2) * this.teethPerPart(partIndex) + toothIndex
        },

        getY(partIndex, conditionIndex) {
            return partIndex < 2 ? conditionIndex : this.conditions.length + conditionIndex + 2
        },

        /**
         * [get coordinates of tooth]
         * @param  {Number} partIndex [Index of the part [0, 1, 2, 3]]
         * @param  {Number} toothIndex [indexOf tooth in that part [0, 1, 2, ..., teeth.length]]
         * @param  {Number} conditionIndex [indexOf condition [0, 1, 2, ..., conditions.length]]
         * @return {[Number, Number]}      [[x, y]]
         */
        getXY(partIndex, toothIndex, conditionIndex) {
            return [this.getX(partIndex, toothIndex), this.getY(partIndex, conditionIndex)]
        }
    }
}
</script>

<style>
.fixedHeight {
    /* border-top:1px solid red; */
    min-height: 23px !important;
    padding-top: 2px;
}

.activeItem {
    background-color: #95AAC9;
}

@media print {

    .btn-square.active {
        -webkit-print-color-adjust: exact !important;
    }

    .btn-square.active::before {
        /* content:'x'; */
    }

}

svg {
    margin: 0;
}

.fil0 {
    fill: none
}

.btn-square {
    width: 18px;
    height: 18px;
}

.btn-square:hover {
    border-color: #f6c343;
}

.btn-square.active {
    background-color: #f6c343 !important;
    border: 0;
}


.badge.active {
    background-color: #f6c343 !important;
    border: 0;
}

svg:hover .fil0 {
    stroke: #f6c343 !important;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);
}

.filRed {
    fill: red
}

.redBorder {
    stroke: #E63757 !important;
}

.str1 {
    stroke: #95AAC9;
    stroke-width: 4;
    stroke-miterlimit: 10
}

.fil1 {
    fill: #fff;
    stroke: #ccc;
    stroke-width: 1;
    stroke-linejoin: round;
    stroke-dasharray: 3;
}

.fil1:hover {
    fill: #EBF1F6;
    stroke: #EC8C9C;
    stroke-width: 2;
    stroke-dasharray: 0;
    /* zoom: 10; */
}

.active {
    fill: #EC8C9C;
    stroke: #fff;
    stroke-dasharray: 0;
}
</style>
